import React from 'react'
import StyledButton from '../../layout_components/StyledButton'
import { Link } from 'react-router-dom'
import { toTitleCase } from '../../../services/helpers/helpers'
import { BsCheckCircleFill } from "react-icons/bs"
// import {MdOutlineCreditCardOff} from "react-icons/md"
import { useState } from 'react'
import "./PriceCards.css"

const PriceCards = ({ plan }) => {
    const [popular, setpopular] = useState(true)
    const tiers = {
        "year": [
            {
                tier: "Free",
                amount: "$0",
                desc: "Sign up for absolutely no cost to explore our platform and assess your internal candidates.",
                values: [
                    "25 Candidate Assessments",
                    "1 Assessment Game",
                    "Access to Test library",
                    "Single Email Invite",
                    "Instant URL Activation",
                    "Candidate Leaderboards",
                ],
                btnText: "START FREE TRIAL"

            },
            {
                tier: "Standard",
                amount: "$1,200",
                desc: "Sign up to unlock more features and assess both internal/external candidates.",
                values: [
                    "300 candidate Assessments",
                    "1 Assessment Game",
                    "Access to Test Library",
                    "Bulk Candidate Invites",
                    "Customizable Data Fields",
                    "Candidate Leaderboards",
                ],
                popular: true

            },
            {
                tier: "Premium",
                amount: "$4,800",
                desc: "Sign up to unlock best features that we offer and assess both internal/external candidates.",
                values: [
                    "1,200 Candidates Assessments",
                    "2 Assessment Games",
                    "Access to Test Library",
                    "Bulk Candidates Invites",
                    "Customizable Data fields",
                    "Candidate Leaderboards"
                ]

            },
            {
                tier: "Enterprise",
                amount: "$10",
                desc: "Contact us to receive a custom quote if you are looking for unlimited candidate assessments.",
                values: [
                    "Unlimited Assessments",
                    "Customized Storyline/ Game Art",
                    "All Premium Features Included",
                    "Unlimited Candidate Invites",
                    "Dedicated Account Manager",
                    "24hrs Email Support"
                ]

            },
        ],


        "quarter": [
            {
                tier: "Free",
                amount: "$0",
                desc: "Sign up for absolutely no cost to explore our platform and assess your internal candidates.",
                values: [
                    "25 Candidate Assessments",
                    "1 Assessment Game",
                    "Access to Test library",
                    "Single Email Invite",
                    "Instant URL Activation",
                    "Candidate Leaderboards",
                ],
                btnText: "START FREE TRIAL"

            },
            {
                tier: "Standard",
                amount: "$400",
                desc: "Sign up to unlock more features and assess both internal/external candidates.",
                values: [
                    "300 candidate Assessments",
                    "1 Assessment Game",
                    "Access to Test Library",
                    "Bulk Candidate Invites",
                    "Customizable Data Fields",
                    "Candidate Leaderboards",
                ],
                popular: true

            },
            {
                tier: "Premium",
                amount: "$1,500",
                desc: "Sign up to unlock best features that we offer and assess both internal/external candidates.",
                values: [
                    "1,200 Candidates Assessments",
                    "2 Assessment Games",
                    "Access to Test Library",
                    "Bulk Candidates Invites",
                    "Customizable Data fields",
                    "Candidate Leaderboards"
                ]

            },
            {
                tier: "Enterprise",
                amount: "$10",
                desc: "Contact us to receive a custom quote if you are looking for unlimited candidate assessments.",
                values: [
                    "Unlimited Assessments",
                    "Customized Storyline/ Game Art",
                    "All Premium Features Included",
                    "Unlimited Candidate Invites",
                    "Dedicated Account Manager",
                    "24hrs Email Support"
                ]

            },
        ],
    }

    const deselectCard = () => {
        setpopular(false)
    }

    return (
        <div className="priceCards flex flex-wrap justify-center w-[20rem] sm:w-[40rem] lg:w-full mx-auto my-14 lg:my-10 ">

            {
                tiers[plan].map((item, cardIndex) => (

                    <div onMouseOver={deselectCard} key={`divCard${item.tier}${cardIndex}`} className={`priceCard group hover:shadow-2xl mb-5 md:mb-0 hover:bg-cover mt-2 hover:bg-cardBg rounded-2xl sm:w-[17rem] md:w-[15rem] lg:w-[16rem] xl:w-[240px] mx-2  px-4 py-4 sm:py-2 lg:py-4 sm:mx-5 sm:my-5  2xl:w-[305px] 2xl:h-[580px] 2xl:pt-4 2xl:px-4 ${item.popular === popular ? 'bg-cardBg bg-cover' : 'bg-white'} border`}>
                        {item.popular &&
                            <div className="popular flex justify-end">
                                <div className="content text-xs bg-[#333333] text-white px-2 py-1 rounded-xl">MOST POPULAR</div>
                            </div>
                        }

                        {
                            !item.popular &&
                            <div className="popular flex justify-end  invisible">
                                <div className="content text-xs bg-[#333333] text-white px-2 py-1 rounded-xl">MOST POPULAR</div>
                            </div>
                        }
                        {item.tier === "Enterprise" && <StyledButton btnText={"Get a Quote"} customStyle="!rounded-xl ml-0 !h-[2.2rem] !text-lg !w-[9rem]" />}

                        {item.tier !== "Enterprise" && <p className="text-gray-900  text-3xl font-bold text-center lg:text-left 2xl:text-[36px] 2xl:leading-[46px]">
                            {item.amount}
                            <span className="text-black  text-sm 2xl:text-[17px] 2xl:leading-[21px]">
                                {item.tier !== "Free" && `/ ${toTitleCase(plan)}`}
                            </span>
                        </p>}
                        <p className="text-gray-800  text-lg font-medium mb-4 text-center lg:text-left mt-3">
                            {item.tier.toUpperCase()} {item.tier === "Free" && <span className='text-[0.6rem] lg:text-[0.5rem] xl:text-[0.6rem] 2xl:text-[0.8rem] text-[#2C94A0] font-bold uppercase'>{'(No Credit Card Required)'}</span>}
                        </p>
                        <p className={`text-gray-600 text-[15px] leading-[19px] mt-4  md:text-[12px] lg:text-[13px] 2xl:text-[16px] 2xl:leading-[23px] xl:text-[12px] h-[3.6rem]  lg:h-[3.6rem] xl:h-[3.8rem] sm:text-[13px] font-[500] ${item.tier === 'Enterprise' && '2xl:mb-[2.15rem]'}`}>
                            {item.desc}
                        </p>
                        <div className="seperator  group-hover: border-[#848199] border-b mt-2 2xl:mt-6"></div>
                        <ul className="text-sm text-gray-600  w-full h-[10rem] lg:h-[9rem] xl:h-[12rem] mt-4 2xl:mt-6 mb-20 sm:mb-0 lg:mb-6 xl:mb-2 2xl:mb-6">

                            {
                                item.values.map((value, index) =>
                                    <li key={`liCardDesc${index}`} className="mb-4 sm:mb2  md:mb-2 lg:mb-2 xl:mb-3 2xl:mb-4 flex items-center sm:text-[12px] md:text-[10px] lg:text-[11px] lg:leading-[10px] 2xl:text-[15px] xl:text-[12px] xl:leading-[16px] 2xl:leading-[23px]">
                                        <BsCheckCircleFill className={` bg-[#FFD700] rounded-2xl text-lg lg:text-[14px] 2xl:text-xl mr-2  group-hover:text-[#333333]  ${item.popular === popular ? 'text-[#333333]' : 'text-[#EDECF9]'}`} />
                                        <p className='font-[500] -mt-[2px]'>{toTitleCase(value)}</p>
                                    </li>
                                )
                            }

                        </ul>

                        {item.tier === "Enterprise" ?
                            <a href="https://thetalentgames.com/book-a-demo-call/" target='_blank' rel='noreferrer'>
                                <button className="py-2 px-4 mt-[40px] bg-[#EBEBEB] hover:bg-[#333333] hover:text-[#FFD700]   
                                w-full transition ease-in duration-200 text-center text-base font-bold focus:outline-none focus:ring-offset-2  
                                rounded-3xl text-[#333333] xl:mt-[1px] 2xl:mt-[48px] lg:mt-[30px] md:mt-[40px]">
                                    BOOK A CALL
                                </button>
                            </a>
                            :
                            <Link to={`/${"Free"}`}>
                                <button className="py-2 px-4  bg-[#EBEBEB] hover:bg-[#333333] hover:text-[#FFD700]   w-full transition ease-in duration-200 text-center text-base font-bold focus:outline-none focus:ring-offset-2  rounded-3xl text-[#333333] z-50 mt-10 md:mt-10 lg:mt-0 2xl:mt-[3rem]">
                                    {
                                        item.btnText || "START FREE TRIAL"
                                    }
                                </button>
                            </Link>
                        }
                    </div>
                ))
            }

        </div>
    )
}

export default PriceCards